/* ---------------------------------------------------------------
   Size guide dialog.

   The theme's own Size Guide button opens an empty modal (the
   variant_picker block's header/description/page settings were never
   filled in). Rather than populate that, the button is taken over
   here and pointed at the dialog in snippets/pdp-size-guide.liquid,
   which reads the size_chart_row metaobjects.

   The cm / inches toggle is CSS only — nothing to do here.
   --------------------------------------------------------------- */

(function () {
	var dialog;
	var lastFocus;

	function open(event) {
		if (!dialog) return;
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		lastFocus = document.activeElement;
		dialog.hidden = false;
		document.documentElement.classList.add('pdp-sizeguide-open');

		var closer = dialog.querySelector('[data-sizeguide-close]');
		if (closer) closer.focus();
	}

	function close() {
		if (!dialog || dialog.hidden) return;
		dialog.hidden = true;
		document.documentElement.classList.remove('pdp-sizeguide-open');
		if (lastFocus && lastFocus.focus) lastFocus.focus();
	}

	function tryOn() {
		var button = document.querySelector('.product__buy_buttons .antla-button');
		close();
		if (button) button.click();
	}

	function init() {
		dialog = document.getElementById('PdpSizeGuide');
		if (!dialog) return;

		// take over the theme's trigger, wherever it renders
		var triggers = document.querySelectorAll('.size-guide-btn');
		for (var i = 0; i < triggers.length; i++) {
			var trigger = triggers[i];
			if (trigger.dataset.sizeguideBound === 'true') continue;
			trigger.dataset.sizeguideBound = 'true';
			trigger.addEventListener('click', open, true);
		}

		if (dialog.dataset.sizeguideBound === 'true') return;
		dialog.dataset.sizeguideBound = 'true';

		dialog.addEventListener('click', function (event) {
			if (event.target.closest('[data-sizeguide-close]')) {
				close();
				return;
			}
			if (event.target.closest('[data-sizeguide-tryon]')) {
				tryOn();
			}
		});

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') close();
		});

		// only offer the try-on route if the app actually rendered
		var tryOnButton = dialog.querySelector('[data-sizeguide-tryon]');
		if (tryOnButton && document.querySelector('.product__buy_buttons .antla-button')) {
			tryOnButton.hidden = false;
		}
	}

	document.addEventListener('shopify:section:load', init);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// the try-on app mounts late; re-check a few times
	var checks = 0;
	var timer = setInterval(function () {
		checks += 1;
		if (checks > 20) {
			clearInterval(timer);
			return;
		}
		if (!dialog) return;
		var tryOnButton = dialog.querySelector('[data-sizeguide-tryon]');
		if (tryOnButton && document.querySelector('.product__buy_buttons .antla-button')) {
			tryOnButton.hidden = false;
			clearInterval(timer);
		}
	}, 300);
})();
